import axios from 'axios';
import proxy from '../../config/proxy';

/*
  **************************************************************************
  api 全局配置
  **************************************************************************
*/

axios.defaults.withCredentials = false; // 允许携带 Cookie
axios.defaults.timeout = 120000; // 请求最大响应时长

axios.defaults.headers.post['Content-Type'] = 'application/json; charset = UTF-8';
axios.defaults.headers.put['Content-Type'] = 'application/json; charset = UTF-8';
axios.defaults.headers.delete['Content-Type'] = 'application/json; charset = UTF-8';

let urls = proxy.config['/api'].target; // 请求地址

// 请求拦截
axios.interceptors.request.use(response => {
    return response;
}, error => {
    return Promise.reject(error);
});

// 响应拦截
axios.interceptors.response.use(async response => {
        return response;
    }, error => {
        return Promise.reject(error);
    }
);

let account = JSON.parse(localStorage.getItem('account'));
let headers = {
    lang: 'cn',
    token: account ? account.token : '',
};

export default {
    getHttp(url) {
        // console.log('this.gutHttpData----->', urls, url, headers);
        return axios({
            url: urls + url,
            method: 'GET',
            headers: headers,
        });
    },
    postHttp(url, data = {}) {
        // console.log('this.postHttp---------->', urls, url, data, headers);
        return axios({
            url: urls + url,
            method: 'POST',
            data: data,
            headers: headers,
        });
    },
    putHttp(url, data) {
        // console.log('this.putHttp---------->', urls, url, data, headers);
        return axios({
            url: urls + url,
            method: 'PUT',
            data: data,
            headers: headers,
        });
    },
    deleteHttp(url, data) {
        // console.log('this.deleteHttp----->', urls, url, data, headers);
        return axios({
            url: urls + url,
            method: 'DELETE',
            data: data,
            headers: headers,
        });
    },
};



// WEBPACK FOOTER //
// ./src/api/index.js